module.exports = __webpack_public_path__ + "static/media/circle-reina.99b63f0a.svg";